export enum NotificationName {
    newRequest = 'newRequest',
    newRequestReminder = 'newRequestReminder',
    expiringRequest = 'expiringRequest',
    expiringRequestReminder = 'expiringRequestReminder',
    nonCompliantRequest = 'nonCompliantRequest',
    nonCompliantRequestReminder = 'nonCompliantRequestReminder',
    newEntityBodyRequest = 'newEntityBodyRequest',
    newEntityBodyRequestReminder = 'newEntityBodyRequestReminder',
    preAdverseAction = 'preAdverseAction',
    postAdverseAction = 'postAdverseAction',
}
